
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/d354bcd0728c30ce902d1dd68b4210ae.png" 
              alt="BIGBATTERY EUROPE" 
              className="h-12 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-blue-900' : 'text-white hover:text-blue-200'}`}
            >
              Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-blue-900' : 'text-white hover:text-blue-200'}`}
            >
              Productos
            </button>
            <button 
              onClick={() => scrollToSection('catalog')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-blue-900' : 'text-white hover:text-blue-200'}`}
            >
              Catálogo
            </button>
            <button 
              onClick={() => scrollToSection('certifications')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-blue-900' : 'text-white hover:text-blue-200'}`}
            >
              Certificaciones
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:text-blue-900' : 'text-white hover:text-blue-200'}`}
            >
              Contacto
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-900 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-800 transition-colors whitespace-nowrap"
            >
              Solicitar Cotización
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
